import React from 'react';
import {
  Row,
  Col,
  Affix,
  Grid,
  Layout,
  Typography,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import debugLib from 'debug';
import { setDrawerVisible } from '../redux/actions/common';
import TNContent from './TNContent';
import { COLOR, FONT } from '../constants';

const debug = debugLib('app:components/AppFooter');
const { Footer } = Layout;
const { Title, Text } = Typography;

const AppFooter = () => {
  // const user = useSelector((state) => state.app.user);
  const dispatch = useDispatch();
  const { STATIC_SERVER_URL } = useSelector((state) => state.app.client.config);
  // const [t, i18n] = useTranslation('header');
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;
  const isTablet = !screens.lg

  const clickMenus = () => {
    dispatch(setDrawerVisible(true));
  };

  return (
    <TNContent maxWidth={1920} color="#000">
      <Footer style={{...styles.lowerFooter,  padding: isMobile ? '40px 24px' : '40px 40px' }}>
        <Row gutter={[0, 36]} justify='space-between' style={{ marginBottom: '3%' }}>
          <Col xs={24} sm={24} xl={9} lg={12} md={12}>
            <Row gutter={[24, 24]}>
              <Col xs={16} sm={16} md={16} lg={12}>
                <img style={{ width: '100%' }} src="./company_logo.png" alt="company logo" />
              </Col>
              <Col span={24} style={{ ...FONT.text, color: '#fff' }}>
                We are a software R&D company and systems integrator with over 50 developers, UX/UI designers who are experienced in app development and blockchain technology focuses on DeFi, GameFi and NFT development
              </Col>
            </Row>
          </Col>
          <Col xs={24} sm={24} lg={10} xl={10}>
            <Row style={{ marginBottom: 8 }}>
              <Col xs={12} sm={10} md={8} lg={12} xl={8} style={{ ...FONT.h6, color: COLOR.whiteText }}>Phone</Col>
              <Col xs={12} sm={10} md={8} lg={12} xl={8} style={{ ...FONT.h6, color: COLOR.whiteText }}>Whatsapp</Col>
            </Row>
            <Row style={{ marginBottom: 20 }}>
              <Col xs={12} sm={10} md={8} lg={12} xl={8} style={isMobile ? { ...FONT.smallCaptionText, color: COLOR.whiteText } : { ...FONT.text, color: COLOR.whiteText }}>(852) 3596 2500</Col>
              <Col xs={12} sm={10} md={8} lg={12} xl={8} style={isMobile ? { ...FONT.smallCaptionText, color: COLOR.whiteText } : { ...FONT.text, color: COLOR.whiteText }}>(852) 5580 9481</Col>
            </Row>
            <Row style={{ marginBottom: 20 }}>
              <Col span={24} style={{ ...FONT.h6, color: COLOR.whiteText }}>Email</Col>
              <Col span={24} style={isMobile ? { ...FONT.smallCaptionText, color: COLOR.whiteText } : { ...FONT.text, color: COLOR.whiteText }}>contact@technine.io</Col>
            </Row>
            <Row style={{ marginBottom: 20 }}>
              <Col span={24} style={{ ...FONT.h6, color: COLOR.whiteText }}>Address</Col>
              <Col span={24} style={isMobile ? { ...FONT.smallCaptionText, color: COLOR.whiteText } : { ...FONT.text, color: COLOR.whiteText }}>28/F, 9 Wing Hong Street, Cheung Sha Wan, Kowloon, Hong Kong  </Col>
            </Row>
            <Row style={{ marginBottom: 20 }}>
              <Col span={24} style={{ ...FONT.h6, color: COLOR.whiteText, marginBottom: 20 }}>FOLLOW US</Col>
              <Col xs={12} sm={12} md={6} lg={10} xl={8}>
                <Row justify='space-between' align='middle'>
                  <Col>
                  <a href="https://www.facebook.com/t9technine/" target="_target" rel="noreferrer">
                    <img src="./assets/facebook_color.svg" alt="Facebook" style={{ width: '100%' }} />
                  </a>
                  </Col>
                  <Col>
                  <a href="https://www.linkedin.com/company/technine/" target="_target" rel="noreferrer">
                    <img src="./assets/linkedin_color.svg" alt="Linkedin" style={{ width: '100%' }} />
                  </a>
                  </Col>
                  <Col>
                  <a href="https://www.visiongo.hsbc.com.hk/zh-HK/company/technine/" target="_target" rel="noreferrer">
                    <img src="./assets/hsbc_color.svg" alt="HSBC" style={{ width: '100%' }} />
                  </a>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={[24, 24]} justify={isMobile ? 'start' : 'space-between'} align='bottom'>
          <Col order={isMobile ? 1 : 0} xs={24} sm={24} md={12} lg={10} xl={8} style={{ ...FONT.smallContent, color: COLOR.whiteText }}>Copyright © 2022. All rights reserved</Col>
          <Col order={isMobile ? 0 : 1} xs={24} sm={24} md={10} lg={8} xl={5}>
            <Row justify={isMobile ? 'start' : 'end'} gutter={[48, 0]}>
              <Col xs={8} md={12}>
                <a href="https://nineblocks.io/" target="_target" rel="noreferrer">
                  <img src="./nineblock.png" alt="" style={{ width: '100%' }} />
                </a>
              </Col>
              <Col xs={8} md={12}>
                <a href="https://technine.io/" target="_target" rel="noreferrer"><img src="./company_logo.png" alt="" style={{ width: '100%', marginTop: 12 }} /></a>
              </Col>
            </Row>
          </Col>
        </Row>
      </Footer>
    </TNContent>
  )
}

const styles = {
  text: {
    // fontWeight: 'bold',
    fontSize: 14,
    color: '#000',
  },
  middleFooter: {
    textAlign: 'center',
    margin: 0,
    padding: '50px 0',
    // paddingBottom: 0,
    backgroundColor: '#FFFFFF',
  },
  lowerFooter: {
    // textAlign: 'center',
    margin: 0,
    // padding: '10px 5% 30px 5%',
    // marginLeft: '5%',
    // marginRight: '5%',
    backgroundColor: '#000',
    // padding: 24
    // paddingTop: '40px',
    // paddingBottom: '40px',
    // padding: '40px 0px'
  },
  icon: {
    color: '#FFFFFF',
    marginRight: 50,
    fontSize: 24,
    transform: 'translateY(20%)',
  },
};

export default AppFooter;
